<div class="countdown-container">
  <muni-shared-order-period
    *ngIf="!!(deal$ | async)"
    class="order-period"
    [deal]="deal$ | async"
  >
    <div class="countdown-footer">Time Remaining</div>
  </muni-shared-order-period>
</div>
